/**
 * FG UTM Tracker
 * Estrae il parametro utm_campaign (?=promo) dall'URL e lo salva in cart.attributes
 * così che possa essere utilizzato per attribution e scheduling UI.
 * Il loader overlay (fg-utm-loader.liquid) è già visibile a questo punto.
 */

(function() {
  function removeUtmOverlay() {
    var el = document.getElementById('fg-utm-overlay');
    if (el) { el.style.transition = 'opacity .3s'; el.style.opacity = '0'; setTimeout(function(){ el.remove(); }, 300); }
  }

  var params;
  try { params = new URLSearchParams(window.location.search); } catch(e) { return; }
  var utm_campaign = (params.get('promo') || '').toLowerCase();
  if (!utm_campaign) return;

  var lastProcessedUTM = sessionStorage.getItem('lastProcessedUTM');
  if (utm_campaign === lastProcessedUTM) { removeUtmOverlay(); return; }

  sessionStorage.setItem('lastProcessedUTM', utm_campaign);

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { utm_campaign: utm_campaign } })
  })
  .then(removeUtmOverlay, removeUtmOverlay);
})();

